// src/components/PaymentFlow/PaymentMethods.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQrcode, faMoneyBill1Wave, faCreditCard, faRightLeft, faUniversity } from '@fortawesome/free-solid-svg-icons';

const PaymentMethods = ({ selectedMethod, onMethodSelect }) => {
  // Obtener los métodos de pago habilitados desde las variables de entorno
  const enabledMethods = process.env.REACT_APP_ENABLED_PAYMENT_METHODS?.split(',') || ['cash'];

  // Definir todos los métodos de pago disponibles con sus íconos
  const allMethods = {
    cash: { id: 'cash', icon: faMoneyBill1Wave, label: 'Efectivo' },
    bank_transfer: { id: 'bank_transfer', icon: faUniversity, label: 'Transferencia' },
    //credit_card: { id: 'credit_card', icon: faCreditCard, label: 'Tarjeta de Crédito' },
    //debit_card: { id: 'debit_card', icon: faCreditCard, label: 'Tarjeta de Débito' },
    //qr: { id: 'qr', icon: faQrcode, label: 'QR' },
    //mercadopago: { 
    //  id: 'mercadopago', 
    //  img: 'https://micuenta.cirenio.com/img/mercadopago.png',
    //  label: 'Mercado Pago'
    //}
  };

  // Filtrar solo los métodos habilitados
  const methods = enabledMethods
    .map(method => allMethods[method])
    .filter(method => method); // Filtrar métodos no definidos

  const handleMethodClick = (method) => {
    onMethodSelect(method.id);
  };

  return (
    <div id="payment-methods" className="payment-methods mt-0">
      <div className="d-flex justify-content-center align-items-center">
        {methods.map((method) => (
          <div
            key={method.id}
            className={`payment-method ${
              selectedMethod === method.id ? 'selected' : ''
            }`}
            onClick={() => handleMethodClick(method)}
            title={method.label}
          >
            {method.icon && (
              <FontAwesomeIcon icon={method.icon} size="2x" />
            )}
            {method.img && (
              <img src={method.img} alt={method.label} style={{ width: '100%' }} />
            )}
          </div>
        ))}
      </div>

      {!methods.length && (
        <div className="alert-danger mt-3 p-1 text-sm border-radius-md" role="alert">
          No hay medios de pago configurados.
        </div>
      )}
    </div>
  );  
};

export default PaymentMethods;
